import { DestinationOption } from '@lt/api/dist/methods/references/types';
import React from 'react';
import { components, ValueContainerProps } from 'react-select';

export const ValueContainer = ({
  children,
  ...props
}: ValueContainerProps<DestinationOption, false>) => {
  const { getValue, isDisabled } = props;

  const [currentValue] = getValue();

  return (
    <>
      <components.ValueContainer {...props}>
        {isDisabled && currentValue ? (
          <span>{currentValue.label || (currentValue as any).destination.label}</span>
        ) : (
          children
        )}
      </components.ValueContainer>
    </>
  );
};
